import React, { createContext, useContext } from "react";
import Layout from "../layout/DefaultLayout";
import { FaArrowUp, FaArrowDown } from "react-icons/fa";
import { FaGlasses, FaRegUserCircle } from "react-icons/fa";
import { Container, Row, Col, Card, Spinner } from "react-bootstrap";
import { IoMdBook } from "react-icons/io";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { useAuth } from "../context/AuthContext";
import { useQuery } from "react-query";
import api from "../utils/helper";

const dataForGraph = [
  { name: "Page A", uv: 10, pv: 1500, amt: 2400 },
  { name: "Page B", uv: 3000, pv: 3098, amt: 2210 },
  { name: "Page C", uv: 2000, pv: 1800, amt: 2290 },
  { name: "Page D", uv: 2000, pv: 4800, amt: 2290 },
];

const Overview = () => {
  const { currentUser, userRole, logout, isAdmin } = useAuth();

  const { data, isLoading, error } = useQuery(
    ["overview", "/overview/super-admin"],
    () => api.get("/overview/super-admin").then((res) => res.data.data),
    {
      staleTime: 5 * 60 * 1000,
    }
  );

  const {
    totals,
    active,
    completedCourses,
    averageTimeSpent,
    trends,
    certificatesIssued,
  } = data || {};

  console.log({ currentUser, userRole, logout, isAdmin }, "frm dashboard");

  const studentChartData =
    trends?.students?.monthWiseTrend?.monthWiseTrend || [];
  const teacherChartData =
    trends?.teachers?.monthWiseTrend?.monthWiseTrend || [];
  const courseChartData = trends?.courses?.monthWiseTrend?.monthWiseTrend || [];

  const studentChartDatas = [
    { name: "Last Month", value: 0 }, // Replace 0 with actual past value if available
    { name: "This Month", value: totals?.students || 0 },
  ];
  const teacherChartDatas = [
    { name: "Last Month", value: 0 }, // Replace 0 with actual past value if available
    { name: "This Month", value: totals?.teachers || 0 },
  ];

  function formatMinutes(decimalMinutes) {
    if (typeof decimalMinutes !== "number" || isNaN(decimalMinutes))
      return "Invalid input";

    const totalMinutes = Math.round(decimalMinutes); // round to nearest minute
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    if (hours > 0 && minutes > 0) {
      return `${hours}h ${minutes} mins`;
    } else if (hours > 0) {
      return `${hours}h`;
    } else {
      return `${minutes} mins`;
    }
  }

  return (
    <Layout>
      <div className="bgNav d-block d-lg-none pb-5 px-1 position-relative">
        <h1 className="heading text-white px-3">Overview</h1>
      </div>
      <Container
        fluid
        className="main-container main-subcontainer mt-0 mt-md-4 ps-auto ps-md-0"
      >
        <Card className="form-card">
          <Card.Header className="heading d-none d-lg-block">
            Overview
          </Card.Header>
          {/* <h1 className="heading d-none d-lg-block">Overview</h1> */}
          <Card.Body>
            <Row className="g-3">
              {/* Example card */}
              <Col md={4}>
                <Card className="d-flex flex-row justify-content-between align-items-end">
                  {/* Left Side: Text Content */}
                  <div className="p-3">
                    <h6 className="allstu mb-1">All Students</h6>
                    {isLoading ? (
                      <div className="d-flex align-items-center p-4">
                        <Spinner size="sm" className="me-2" />
                        <span>Loading...</span>
                      </div>
                    ) : (
                      <>
                        <h3 className="fw-bold mb-1">
                          {totals?.students ?? 0}
                        </h3>
                        <p
                          className={`d-flex align-items-center mb-0 ${
                            trends?.students?.increase
                              ? "text-success"
                              : "text-danger"
                          }`}
                        >
                          {trends?.students?.increase ? (
                            <FaArrowUp className="me-1" />
                          ) : (
                            <FaArrowDown className="me-1" />
                          )}{" "}
                          {trends?.students?.percentage}%{" "}
                          <span className="text-muted ms-1">vs last month</span>
                        </p>
                      </>
                    )}
                  </div>

                  {/* Right Side: Chart */}
                  <div
                    style={{ width: "100px", height: "50px" }}
                    className="pe-3"
                  >
                    <ResponsiveContainer width="100%" height="100%">
                      <LineChart data={studentChartData}>
                        <XAxis dataKey="name" hide />
                        <YAxis hide />
                        <Tooltip />
                        <Line
                          type="monotone"
                          dataKey="percentage"
                          stroke={
                            trends?.students?.increase ? "#12B76A" : "#f04438"
                          }
                          strokeWidth={2}
                          dot={false}
                        />
                      </LineChart>
                    </ResponsiveContainer>
                  </div>
                </Card>
              </Col>

              <Col md={4}>
                <Card className="d-flex flex-row justify-content-between align-items-end">
                  {/* Left Side: Text Content */}
                  <div className="p-3">
                    <h6 className="allstu mb-1">All Teachers</h6>
                    {isLoading ? (
                      <div className="d-flex align-items-center p-4">
                        <Spinner size="sm" className="me-2" />
                        <span>Loading...</span>
                      </div>
                    ) : (
                      <>
                        <h3 className="fw-bold mb-1">
                          {totals?.teachers ?? 0}
                        </h3>
                        <p
                          className={`d-flex align-items-center mb-0 ${
                            trends?.teachers?.increase
                              ? "text-success"
                              : "text-danger"
                          }`}
                        >
                          {trends?.teachers?.increase ? (
                            <FaArrowUp className="me-1" />
                          ) : (
                            <FaArrowDown className="me-1" />
                          )}{" "}
                          {trends?.teachers?.percentage}%{" "}
                          <span className="text-muted ms-1">vs last month</span>
                        </p>
                      </>
                    )}
                  </div>

                  {/* Right Side: Chart */}
                  <div
                    style={{ width: "100px", height: "50px" }}
                    className="pe-3"
                  >
                    <ResponsiveContainer width="100%" height="100%">
                      <LineChart data={teacherChartData}>
                        <XAxis dataKey="name" hide />
                        <YAxis hide />
                        <Tooltip />
                        <Line
                          type="monotone"
                          dataKey="percentage"
                          stroke={
                            trends?.teachers?.increase ? "#12B76A" : "#f04438"
                          }
                          strokeWidth={2}
                          dot={false}
                        />
                      </LineChart>
                    </ResponsiveContainer>
                  </div>
                </Card>
              </Col>

              <Col md={4}>
                <Card className="d-flex flex-row justify-content-between align-items-end">
                  {/* Left Side: Text Content */}
                  <div className="p-3">
                    <h6 className="allstu mb-1">All Courses</h6>
                    {isLoading ? (
                      <div className="d-flex align-items-center p-4">
                        <Spinner size="sm" className="me-2" />
                        <span>Loading...</span>
                      </div>
                    ) : (
                      <>
                        <h3 className="fw-bold mb-1">{totals?.courses ?? 0}</h3>
                        <p
                          className={`d-flex align-items-center mb-0 ${
                            trends?.courses?.increase
                              ? "text-success"
                              : "text-danger"
                          }`}
                        >
                          {trends?.courses?.increase ? (
                            <FaArrowUp className="me-1" />
                          ) : (
                            <FaArrowDown className="me-1" />
                          )}{" "}
                          {trends?.courses?.percentage}%{" "}
                          <span className="text-muted ms-1">vs last month</span>
                        </p>
                      </>
                    )}
                  </div>

                  {/* Right Side: Chart */}
                  <div
                    style={{ width: "100px", height: "50px" }}
                    className="pe-3"
                  >
                    <ResponsiveContainer width="100%" height="100%">
                      <LineChart data={courseChartData}>
                        <XAxis dataKey="name" hide />
                        <YAxis hide />
                        <Tooltip />
                        <Line
                          type="monotone"
                          dataKey="percentage"
                          stroke={
                            trends?.courses?.increase ? "#12B76A" : "#f04438"
                          }
                          strokeWidth={2}
                          dot={false}
                        />
                      </LineChart>
                    </ResponsiveContainer>
                  </div>
                </Card>
              </Col>

              <Col md={4}>
                <Card className="p-3 gap-2">
                  <h6 className="allstu mb-0">Students Active</h6>
                  {isLoading ? (
                    <div className="d-flex align-items-center p-4">
                      <Spinner size="sm" className="me-2" />
                      <span>Loading...</span>
                    </div>
                  ) : (
                    <h3 className="mb-0 fw-600">{active?.students ?? 0}</h3>
                  )}
                </Card>
              </Col>

              <Col md={4}>
                <Card className="p-3 gap-2">
                  <h6 className="allstu mb-0">Teachers Active</h6>
                  {isLoading ? (
                    <div className="d-flex align-items-center p-4">
                      <Spinner size="sm" className="me-2" />
                      <span>Loading...</span>
                    </div>
                  ) : (
                    <h3 className="mb-0 fw-600">{active?.teachers ?? 0}</h3>
                  )}
                </Card>
              </Col>

              <Col md={4}>
                <Card className="p-3 gap-2">
                  <h6 className="allstu mb-0">Courses Completed</h6>
                  {isLoading ? (
                    <div className="d-flex align-items-center p-4">
                      <Spinner size="sm" className="me-2" />
                      <span>Loading...</span>
                    </div>
                  ) : (
                    <h3 className="mb-0 fw-600">{completedCourses ?? 0}</h3>
                  )}
                </Card>
              </Col>

              <Col md={4}>
                <Card className="p-3 gap-2">
                  <h6 className="allstu mb-0">Certificates Issued</h6>
                  {isLoading ? (
                    <div className="d-flex align-items-center p-4">
                      <Spinner size="sm" className="me-2" />
                      <span>Loading...</span>
                    </div>
                  ) : (
                    <h3 className="mb-0 fw-600">
                      {totals?.certificatesIssued ?? 0}
                    </h3>
                  )}
                </Card>
              </Col>

              <Col md={4}>
                <Card className="p-3 gap-2">
                  <h6 className="allstu mb-0">Average Student Time</h6>
                  {isLoading ? (
                    <div className="d-flex align-items-center p-4">
                      <Spinner size="sm" className="me-2" />
                      <span>Loading...</span>
                    </div>
                  ) : (
                    <h3 className="mb-0 fw-600">
                      {formatMinutes(averageTimeSpent?.student ?? 0)}
                    </h3>
                  )}
                </Card>
              </Col>

              <Col md={4}>
                <Card className="p-3 gap-2">
                  <h6 className="allstu mb-0">Average Teacher Time</h6>
                  {isLoading ? (
                    <div className="d-flex align-items-center p-4">
                      <Spinner size="sm" className="me-2" />
                      <span>Loading...</span>
                    </div>
                  ) : (
                    <h3 className="mb-0 fw-600">
                      {formatMinutes(averageTimeSpent?.teacher ?? 0)}
                    </h3>
                  )}
                </Card>
              </Col>
            </Row>
            <div className="mt-5">
              <h2 className="quickAdd">Quick Add</h2>
              <div className="d-flex flex-column flex-md-row gap-3">
                <div className="">
                  <Card
                    as={Link}
                    to="/add-student"
                    className="d-flex flex-row gap-2 align-items-center quick-btn text-decoration-none"
                  >
                    <img
                      className="quick-icons"
                      src="./images/addStudent.png"
                    />
                    <h6 className="mb-0">Add Students</h6>
                  </Card>
                </div>
                <div className="">
                  <Card
                    as={Link}
                    to="/add-teacher"
                    className="d-flex flex-row gap-2 align-items-center quick-btn text-decoration-none"
                  >
                    <img
                      className="quick-icons"
                      src="./images/addTeacher.png"
                    />
                    <h6 className="mb-0">Add Teachers</h6>
                  </Card>
                </div>
                <div className="">
                  <Card
                    as={Link}
                    to="/add-course"
                    className="d-flex flex-row gap-2 align-items-center quick-btn text-decoration-none"
                  >
                    <img className="quick-icons" src="./images/addCourse.png" />
                    <h6 className="mb-0">Add Courses</h6>
                  </Card>
                </div>
              </div>
            </div>
          </Card.Body>
        </Card>
      </Container>
      <Footer />
    </Layout>
  );
};

export default Overview;
